import { LocalizationProvider, TimeField } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useEffect, useState } from "react";
import { lngs } from "../../Constant";
import { enUS, svSE } from "@mui/x-date-pickers/locales";
import en from "date-fns/locale/en-US";
import sv from "date-fns/locale/sv";

export const MyTimePicker = (props) => {
  const [selectedDate, setSelectedDate] = useState(props.value ? new Date(props.value) : null);

  const handleTimeChange = (date) => {
    if (date != "Invalid Date") {
      props.onAccept(date);
    } else props.onAccept(null);
  };

  useEffect(() => {
    setSelectedDate(props.value ? new Date(props.value) : null);
  }, [props.value]);

  let error = props.helperText !== "" && props.helperText !== null && props.helperText !== undefined;
  const className = "w-100 mt-3 mb-3 " + props.className;

  const locale = props.locale == lngs.en.code ? enUS : svSE;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} localeText={{ ...locale.components.MuiLocalizationProvider.defaultProps.localeText, fieldHoursPlaceholder: (params) => "HH" }} adapterLocale={props.locale == lngs.en.code ? en : sv}>
      <TimeField
        ampm={false}
        className={className}
        helperText={props.helperText}
        variant="outlined"
        label={props.label}
        value={selectedDate}
        onChange={handleTimeChange}
        required={props.required}
        slotProps={{
          textField: {
            id: props.id,
            placeholder: "HH:mm",
            required: props.required,
            error: error,
            helperText: props.helperText,
          },
        }}
      />
    </LocalizationProvider>
  );
};
